/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui'
import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { RegionalLink } from '../atoms'
import { GatsbyImage } from 'gatsby-plugin-image'

class ModuleLink extends React.Component {
  render() {
    const fontSize = 0
    const { title, slug, icon, iconAlt, iconTitle, regional } = this.props
    return (
      <RegionalLink
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'nowrap',
          color: 'light',
          textDecoration: 'none',
          fontWeight: 'normal',
          textTransform: 'uppercase',
          borderWidth: 0,
          mx: 3,
          mb: '0px',
          px: 3,
          mt: '5rem',
          borderBottomWidth: '5px',
          borderColor: 'transparent',
          borderStyle: 'solid',
          opacity: 0.8,
          '&:hover, &:focus': {
            borderColor: 'rgba(255, 255, 255, 0.5)',
            '& img': {
              boxShadow: '1px 1px 2px 2px rgba(255, 255, 255, 0.5)',
            },
          },
          '&.active': {
            borderColor: 'rgba(255, 255, 255, 0.95)',
            opacity: 1,
            '& img': {
              boxShadow: '1px 1px 2px 2px rgba(255, 255, 255, 0.5)',
            },
          },
        }}
        activeClassName="active"
        className="module-link"
        to={`/${slug}/`}
        regional={regional}
      >
        {icon ?
          <GatsbyImage
            image={icon.gatsbyImageData}
            sx={{ borderRadius: 75, padding: 0, width: 60, height: 60}}
            alt={iconAlt}
            title={iconTitle}
          /> : null}
        <div
          sx={{
            my: 2,
            midWidth: 0,
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            border: '0px solid blue',
            textAlign: 'center',
            fontSize,
          }}
        >
          {title}
        </div>
      </RegionalLink>
    )
  }
}

ModuleLink.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
}

export default ModuleLink
